import { toLocalInput } from "./shiftUtils";

/**
 * DurationChips — one-tap preset buttons next to the End picker.
 *
 * Given a start_time (in the same "YYYY-MM-DDTHH:mm" local-input shape
 * the datetime picker uses), clicking a chip sets end_time = start + Nh.
 *
 * Highlights the currently-selected preset when the gap between start
 * and end matches within a 60-second grace window (native datetime
 * pickers can emit ISO strings with second-level jitter).
 */

const PRESETS = [
  { hours: 4,  label: "4h" },
  { hours: 8,  label: "8h" },
  { hours: 12, label: "12h" },
  { hours: 24, label: "24h" },
];

export default function DurationChips({ startLocal, endLocal, onPick, disabled = false, testIdPrefix = "shift-duration" }) {
  const start = startLocal ? new Date(startLocal) : null;
  const end = endLocal ? new Date(endLocal) : null;
  const currentHours = (start && end && !isNaN(start) && !isNaN(end))
    ? (end.getTime() - start.getTime()) / 3_600_000
    : null;

  const apply = (hours) => {
    if (!start || isNaN(start)) return;
    const nextEnd = new Date(start.getTime() + hours * 3_600_000);
    onPick(toLocalInput(nextEnd.toISOString()));
  };

  return (
    <div className="flex items-center gap-1.5 flex-wrap mt-2" data-testid={`${testIdPrefix}-chips`}>
      <span className="text-[10px] uppercase tracking-widest text-zinc-500 mr-1">
        Duration
      </span>
      {PRESETS.map((p) => {
        const active = currentHours !== null && Math.abs(currentHours - p.hours) < 0.017;  // <1 min
        return (
          <button
            key={p.hours}
            type="button"
            disabled={disabled || !start || isNaN(start)}
            onClick={() => apply(p.hours)}
            data-testid={`${testIdPrefix}-chip-${p.hours}h`}
            className={`px-2.5 py-1 text-[10px] uppercase tracking-widest font-mono font-bold border transition-colors ${
              active
                ? "bg-[#FF3B30] border-[#FF3B30] text-white"
                : "border-[#27272A] text-zinc-400 hover:border-zinc-500 hover:text-zinc-200"
            } ${disabled || !start || isNaN(start) ? "opacity-40 cursor-not-allowed" : ""}`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
